import { Fade, Typography } from 'components/common'
import { FlexBoxHover } from 'components/common/StyledBoxes'
import StyledTooltip from 'components/Tooltip/Tooltip'
import {
  DemoTooltipText,
  useCollectiveDemoContext
} from 'context/CollectiveDemoContext'
import { noop } from 'lodash'
import Image from 'next/image'
import { twMerge } from 'tailwind-merge'

type IProps = {
  disabled?: boolean
  image: string
  imageWidth?: number
  imageHeight?: number
  text: string
  children?: React.ReactNode
}

export const DemoWalletTypes: React.FC<IProps> = ({
  children,
  disabled = false,
  image,
  text,
  imageWidth = 30,
  imageHeight = 30
}) => {
  const { setDemoWalletLinking } = useCollectiveDemoContext()

  return (
    <Fade in>
      <StyledTooltip title={disabled ? DemoTooltipText : ''} arrow>
        <div className="w-1/2">
          <FlexBoxHover
            className={twMerge(
              'flex-1 p-2 items-center rounded-xl gap-2 border border-solid border-[rgba(0,0,0,0.12)]',
              disabled && 'bg-gray-200'
            )}
            onClick={
              !disabled ? () => setDemoWalletLinking('connecting') : noop
            }
          >
            {children}
            <div className="p-2 flex justify-center border border-solid border-gray-200 h-[50px] items-center">
              <Image
                src={image}
                width={imageWidth}
                height={imageHeight}
                alt="Demo of wallet types"
              />
            </div>

            <Typography>{text}</Typography>
          </FlexBoxHover>
        </div>
      </StyledTooltip>
    </Fade>
  )
}
